export default __webpack_public_path__ + "static/media/3.ff6871b6.svg";